module.exports = __webpack_public_path__ + "static/img/logoh5.b963ea64.png";